import { Component } from '@angular/core'
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core'
import { Subject } from 'rxjs'

@Component({
  selector: 'basin-formly-searchbox',
  templateUrl: './formly-searchbox.component.html',
  styleUrls: ['./formly-searchbox.component.scss'],
})
export class FormlySearchboxComponent extends FieldType {
  clearSearch() {
    this.options.resetModel()
  }

  actionDescriptionClicked(event: Event) {
    const actionDescriptionClicked$ = this.props
      .actionDescriptionClicked as Subject<{
      field: FormlyFieldConfig
      event: Event
    }>
    actionDescriptionClicked$ &&
      actionDescriptionClicked$.next({ field: this.field, event })
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Home' || event.key === 'End') {
      event.stopPropagation()
    }
  }
}
